/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Row,
  Col
} from "reactstrap";

import {Component} from 'react';

import {signIn,signOut} from 'App/auth/auth_service';
import Authenticator from "aws-amplify-react";
import {Auth} from "aws-amplify";
import {Redirect, Route} from "react-router-dom";
import {history} from "../../_helpers/history";

class Login extends Component {

  state = {
    loading: true,
    isAuthenticated: false,
    require_new_password: false,
  }

  constructor(props) {
    super(props);
    this._validAuthStates = ["signIn", "signedOut", "signedUp"];
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmission = this.handleFormSubmission.bind(this);
    this.onNewPasswordConfirm = this.onNewPasswordConfirm.bind(this);
    this.state = {};

    signOut();

    Auth.currentAuthenticatedUser().then((isAuthenticated) => {
      this.setState({
        loading: false,
        isAuthenticated,
      });
    }).catch((error) => {
      this.setState({
        loading: false,
        isAuthenticated: false,
      });
    });
  }

  handleFormSubmission(evt) {
    evt.preventDefault();

    const email = this.inputs.email;
    const password = this.inputs.password;

    signIn(email, password).then(user => {
      if(user != null){
        if(user.challengeName === 'NEW_PASSWORD_REQUIRED'){
          this.setState({require_new_password: true, currentPassword: password, email: email})
        } else {
          history.push('/');
        }
      }
    });
  }

  onNewPasswordConfirm(evt) {
    evt.preventDefault();

    const email = this.state.email;
    const current_password = this.state.currentPassword;
    const new_password = this.inputs.password;

    if(new_password == null) return;

    signIn(email, current_password).then(user => {
      if(user != null){
        if(user.challengeName === 'NEW_PASSWORD_REQUIRED'){
          Auth.completeNewPassword( user, new_password, )
              .then(user => {
                history.push('/');
              })
              .catch(err => {
                console.log(err);
              });

        } else {
          history.push('/');
        }
      }
    });
  }

  handleInputChange(evt) {
    this.inputs = this.inputs || {};
    const { name, value, type, checked } = evt.target;
    const check_type = ["radio", "checkbox"].includes(type);
    this.inputs[name] = check_type ? checked : value;
    this.inputs["checkedValue"] = check_type ? value : null;
    this.setState({ error: "" });
  }

  render() {
    const { component: Component, ...rest } = this.props;
    if (this.state.loading) {
      return <div>LOADING</div>;
    } else {
      return (
          <Route {...rest} render={props => (
              <div>
                {this.state.isAuthenticated && <Redirect to={{ pathname: '/', state: { from: this.props.location } }} />}
                <Col lg="5" md="7" className="login-div">
                  <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-5">
                      <div className="text-center text-muted mb-4">
                        <h1>Securetary</h1>
                      </div>
                    </CardHeader>
                    <CardBody className="px-lg-5 py-lg-5">
                      <h2>Login</h2>
                      {!this.state.require_new_password && <Form role="form">
                        <FormGroup className="mb-3">
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                                id="email"
                                key="email"
                                name="email"
                                onChange={this.handleInputChange}
                                placeholder="Email" type="email" autoComplete="new-email"/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-lock-circle-open" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input id="password"
                                   key="password"
                                   name="password"
                                   onChange={this.handleInputChange}
                                   placeholder="Password" type="password" autoComplete="new-password"/>
                          </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                          <Button className="my-4" color="primary" type="submit" onClick={this.handleFormSubmission}>
                            Sign in
                          </Button>
                        </div>
                      </Form>}
                      {this.state.require_new_password && <Form role="form">
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-lock-circle-open" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input id="password"
                                   key="password"
                                   name="password"
                                   onChange={this.handleInputChange}
                                   placeholder="New Password" type="password" autoComplete="new-password"/>
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-lock-circle-open" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input id="confirm_password"
                                   key="confirm_password"
                                   name="confirm_password"
                                   onChange={this.handleInputChange}
                                   placeholder="Confirm Password" type="password" autoComplete="new-password"/>
                          </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                          <Button className="my-4" color="primary" type="submit" onClick={this.onNewPasswordConfirm}>
                            Update Password
                          </Button>
                        </div>
                      </Form>}
                    </CardBody>
                  </Card>
                </Col>
              </div>
          )}
          />
      )
    }
  }
}

export default Login;
